import { render, staticRenderFns } from "./InventoryImportDetail.vue?vue&type=template&id=4ae5f9d3&scoped=true&"
import script from "./InventoryImportDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryImportDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryImportDetail.vue?vue&type=style&index=0&id=4ae5f9d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae5f9d3",
  null
  
)

export default component.exports